/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FilterLogicalOperator,
    FilterLogicalOperatorFromJSON,
    FilterLogicalOperatorFromJSONTyped,
    FilterLogicalOperatorToJSON,
    SortingDto,
    SortingDtoFromJSON,
    SortingDtoFromJSONTyped,
    SortingDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetAllContractorsQuery
 */
export interface GetAllContractorsQuery {
    /**
     * 
     * @type {number}
     * @memberof GetAllContractorsQuery
     */
    page?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetAllContractorsQuery
     */
    pageSize?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetAllContractorsQuery
     */
    skip?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAllContractorsQuery
     */
    take?: number;
    /**
     * 
     * @type {FilterLogicalOperator}
     * @memberof GetAllContractorsQuery
     */
    filterLogicalOperator?: FilterLogicalOperator;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetAllContractorsQuery
     */
    filterKeys?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<SortingDto>}
     * @memberof GetAllContractorsQuery
     */
    sortings?: Array<SortingDto> | null;
}

export function GetAllContractorsQueryFromJSON(json: any): GetAllContractorsQuery {
    return GetAllContractorsQueryFromJSONTyped(json, false);
}

export function GetAllContractorsQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllContractorsQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'skip': !exists(json, 'skip') ? undefined : json['skip'],
        'take': !exists(json, 'take') ? undefined : json['take'],
        'filterLogicalOperator': !exists(json, 'filterLogicalOperator') ? undefined : FilterLogicalOperatorFromJSON(json['filterLogicalOperator']),
        'filterKeys': !exists(json, 'filterKeys') ? undefined : json['filterKeys'],
        'sortings': !exists(json, 'sortings') ? undefined : (json['sortings'] === null ? null : (json['sortings'] as Array<any>).map(SortingDtoFromJSON)),
    };
}

export function GetAllContractorsQueryToJSON(value?: GetAllContractorsQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'skip': value.skip,
        'take': value.take,
        'filterLogicalOperator': FilterLogicalOperatorToJSON(value.filterLogicalOperator),
        'filterKeys': value.filterKeys,
        'sortings': value.sortings === undefined ? undefined : (value.sortings === null ? null : (value.sortings as Array<any>).map(SortingDtoToJSON)),
    };
}


